<template>
  <App>
    <ul class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-8">
      <li class="nav-item">
        <a class="nav-link text-active-primary pb-4 active" data-bs-toggle="tab" href="#principais">Configurações Gerais</a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-active-primary pb-4" data-kt-countup-tabs="true" data-bs-toggle="tab" href="#site">Configurações do Site</a>
      </li>
    </ul>
    <div class="row mb-3">
      <form class="form fv-plugins-bootstrap5 fv-plugins-framework" novalidate="novalidate" enctype="multipart/form-data" @submit.prevent="submit">
        <div class="tab-content">
          <div id="principais" role="tabpanel" class="tab-pane fade active show">
            <form-body :loading="form.processing || loading" :form="form">
<!--              <div class="row mb-3">-->
<!--                <div class="col-12">-->
<!--                  &lt;!&ndash;            <form-group label="Layout Certificado (imagem background utilizada na geração do certificado)" :is-invalid="form.errors.imagem_certificado">&ndash;&gt;-->
<!--                  &lt;!&ndash;              <input&ndash;&gt;-->
<!--                  &lt;!&ndash;                  v-model="form.imagem_certificado"&ndash;&gt;-->
<!--                  &lt;!&ndash;                  class="form-control"&ndash;&gt;-->
<!--                  &lt;!&ndash;                  type="file"&ndash;&gt;-->
<!--                  &lt;!&ndash;                  accept="image/jpeg;image/png;image/jpg"&ndash;&gt;-->
<!--                  &lt;!&ndash;                  placeholder="Layout Certificado"&ndash;&gt;-->
<!--                  &lt;!&ndash;                  @blur="form.clearErrors('imagem_certificado')"&ndash;&gt;-->
<!--                  &lt;!&ndash;                  :class="{'is-invalid' : form.errors.imagem_certificado}"&ndash;&gt;-->
<!--                  &lt;!&ndash;                  maxlength="150"&ndash;&gt;-->
<!--                  &lt;!&ndash;              />&ndash;&gt;-->
<!--                  &lt;!&ndash;            </form-group>&ndash;&gt;-->
<!--                </div>-->
<!--              </div>-->
              <div class="row mb-3">
                <div class="col-2">
                  <form-group label="Data da Mostra" :is-invalid="form.errors.data_mostra">
                    <datepicker
                        @input="form.data_mostra = $event"
                        placeholder="Data da Mostra"
                        ref="data_mostra"
                        :value="form.data_mostra"
                        :addClass="'datepicker'"
                        :isInvalid="form.errors.data_mostra"
                    ></datepicker>
                  </form-group>
                </div>

                <div class="col-2">
                  <form-group label="Início das Inscrições" :is-invalid="form.errors.inicio_inscricao">
                    <datepicker
                        @input="form.inicio_inscricao = $event"
                        placeholder="Início das Inscrições"
                        ref="inicio_inscricao"
                        :value="form.inicio_inscricao"
                        :addClass="'datepicker'"
                        :isInvalid="form.errors.inicio_inscricao"
                    ></datepicker>
                  </form-group>
                </div>

                <div class="col-2">
                  <form-group label="Término das Inscrições" :is-invalid="form.errors.termino_inscricao">
                    <datepicker
                        @input="form.termino_inscricao = $event"
                        placeholder="Término das Inscrições"
                        ref="termino_inscricao"
                        :value="form.termino_inscricao"
                        :addClass="'datepicker'"
                        :isInvalid="form.errors.termino_inscricao"
                    ></datepicker>
                  </form-group>
                </div>

                <div class="col-2">
                  <form-group label="Data Resumo" :is-invalid="form.errors.data_resumo">
                    <datepicker
                        @input="form.data_resumo = $event"
                        placeholder="Data Resumo"
                        ref="data_resumo"
                        :value="form.data_resumo"
                        :addClass="'datepicker'"
                        :isInvalid="form.errors.data_resumo"
                    ></datepicker>
                  </form-group>
                </div>

                <div class="col-2">
                  <form-group label="Data Resumo Final" :is-invalid="form.errors.data_resumo_final">
                    <datepicker
                        @input="form.data_resumo_final = $event"
                        placeholder="Data Resumo"
                        ref="data_resumo_final"
                        :value="form.data_resumo_final"
                        :addClass="'datepicker'"
                        :isInvalid="form.errors.data_resumo_final"
                    ></datepicker>
                  </form-group>
                </div>

                <div class="col-2">
                  <form-group label="Data Poster" :is-invalid="form.errors.data_poster">
                    <datepicker
                        @input="form.data_poster = $event"
                        placeholder="Data Poster"
                        ref="data_poster"
                        :value="form.data_poster"
                        :addClass="'datepicker'"
                        :isInvalid="form.errors.data_poster"
                    ></datepicker>
                  </form-group>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-2">
                  <form-group label="N. do Certificado" :is-invalid="form.errors.certificado_numero">
                    <input
                        v-model="form.certificado_numero"
                        class="form-control"
                        type="text"
                        placeholder="N. do Certificado"
                        @blur="form.clearErrors('certificado_numero')"
                        :class="{'is-invalid' : form.errors.certificado_numero}"
                        maxlength="150"
                    />
                  </form-group>
                </div>

                <div class="col-2">
                  <form-group label="Sequência do Certificado" :is-invalid="form.errors.certificado_sequencia">
                    <input
                        v-model="form.certificado_sequencia"
                        class="form-control"
                        type="text"
                        placeholder="Sequência do Certificado"
                        @blur="form.clearErrors('certificado_sequencia')"
                        :class="{'is-invalid' : form.errors.certificado_sequencia}"
                        maxlength="150"
                    />
                  </form-group>
                </div>

                <div class="col-2">
                  <form-group label="N. do Certificado (Prof)" :is-invalid="form.errors.certificado_numero_ori">
                    <input
                        v-model="form.certificado_numero_ori"
                        class="form-control"
                        type="text"
                        placeholder="N. do Certificado (Prof)"
                        @blur="form.clearErrors('certificado_numero_ori')"
                        :class="{'is-invalid' : form.errors.certificado_numero_ori}"
                        maxlength="150"
                    />
                  </form-group>
                </div>

                <div class="col-2">
                  <form-group label="Seq. do Certificado (Prof)" :is-invalid="form.errors.certificado_sequencia_ori">
                    <input
                        v-model="form.certificado_sequencia_ori"
                        class="form-control"
                        type="text"
                        placeholder="Sequência do Certificado (Prof)"
                        @blur="form.clearErrors('certificado_sequencia_ori')"
                        :class="{'is-invalid' : form.errors.certificado_sequencia_ori}"
                        maxlength="150"
                    />
                  </form-group>
                </div>

                <div class="col-3">
                  <form-group label="Processo do Certificado" :is-invalid="form.errors.certificado_processo">
                    <input
                        v-model="form.certificado_processo"
                        class="form-control"
                        type="text"
                        placeholder="Processo do Certificado"
                        @blur="form.clearErrors('certificado_processo')"
                        :class="{'is-invalid' : form.errors.certificado_processo}"
                        maxlength="255"
                    />
                  </form-group>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-2">
                  <form-group label="Avaliador Interesses" :is-invalid="form.errors.avaliador_interesses">
                    <template #actions>
                      <i class="bi bi-info-circle-fill text-gray-900"
                         data-bs-toggle="tooltip"
                         data-bs-trigger="hover"
                         data-bs-html="true"
                         data-bs-original-title="Quantidade de interesses que o avaliador precisa ter para ser encontrado no sorteio dos projetos. <b>Quanto mais interesses mais preciso é o sorteio e mais avaliadores são recomendados, caso contrário projetos ficarão sem avaliador.</b>"
                      ></i>
                    </template>
                    <input
                        v-model="form.avaliador_interesses"
                        class="form-control"
                        type="number"
                        placeholder="Avaliador Interesses"
                        @blur="form.clearErrors('avaliador_interesses')"
                        :class="{'is-invalid' : form.errors.avaliador_interesses}"
                    />
                  </form-group>
                </div>

                <div class="col-2">
                  <form-group label="Avaliador Projetos" :is-invalid="form.errors.avaliador_projetos">
                    <template #actions>
                      <i class="bi bi-info-circle-fill text-gray-900"
                         data-bs-toggle="tooltip"
                         data-bs-trigger="hover"
                         data-bs-html="true"
                         data-bs-original-title="Quantidade de projetos que um avaliador poderá avaliar. Esse configuração é aplicada somente no sorteio. Caso haja necessidade de inserir o avaliador manualmente ao projeto isto não será considerado."
                      ></i>
                    </template>
                    <input
                        v-model="form.avaliador_projetos"
                        class="form-control"
                        type="number"
                        placeholder="Avaliador Projetos"
                        @blur="form.clearErrors('avaliador_projetos')"
                        :class="{'is-invalid' : form.errors.avaliador_projetos}"
                    />
                  </form-group>
                </div>

                <div class="col-2">
                  <form-group label="Projeto Avaliadores" :is-invalid="form.errors.projeto_avaliador">
                    <template #actions>
                      <i class="bi bi-info-circle-fill text-gray-900"
                         data-bs-toggle="tooltip"
                         data-bs-trigger="hover"
                         data-bs-html="true"
                         data-bs-original-title="Quantidade de avaliadores que um projeto deverá conter. Esse configuração é aplicada somente no sorteio. Caso haja necessidade de inserir o avaliador manualmente ao projeto isto não será considerado."
                      ></i>
                    </template>
                    <input
                      v-model="form.projeto_avaliador"
                      class="form-control"
                      type="number"
                      placeholder="Projeto Avaliadores"
                      @blur="form.clearErrors('projeto_avaliador')"
                      :class="{'is-invalid' : form.errors.projeto_avaliador}"
                    />
                  </form-group>
                </div>
              </div>
            </form-body>
          </div>

          <div id="site" role="tabpanel" class="tab-pane fade">
            <form-body :loading="form.processing || loading" :form="form">
              <div class="row mb-3">
<!--                <div class="col-3">-->
<!--                  <form-group label="Informativo botão site" :is-invalid="form.errors.informativo_botao_site">-->
<!--                    <input-->
<!--                      v-model="form.informativo_botao_site"-->
<!--                      class="form-control"-->
<!--                      type="text"-->
<!--                      placeholder="Informativo botão site"-->
<!--                      @blur="form.clearErrors('certificado_processo')"-->
<!--                      :class="{'is-invalid' : form.errors.informativo_botao_site}"-->
<!--                      maxlength="255"-->
<!--                    />-->
<!--                  </form-group>-->
<!--                </div>-->

                <div class="col-3">
                  <form-group label="Pôster Modelo" :is-invalid="form.errors.poster_modelo">
                    <input
                      class="form-control"
                      @input="form.poster_modelo = $event.target.files[0]"
                      type="file"
                      placeholder="Pôster Modelo"
                      accept=".csv,.doc,.docx,.ppt,.pptx,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf"
                      @blur="form.clearErrors('poster_modelo')"
                      :class="{'is-invalid' : form.errors.poster_modelo}"
                    />
                  </form-group>
                </div>

                <div class="col-3">
                  <form-group label="Resumo Modelo" :is-invalid="form.errors.resumo_modelo">
                    <input
                      class="form-control"
                      @input="form.resumo_modelo = $event.target.files[0]"
                      type="file"
                      placeholder="Resumo Modelo"
                      accept=".csv,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf"
                      @blur="form.clearErrors('resumo_modelo')"
                      :class="{'is-invalid' : form.errors.resumo_modelo}"
                    />
                  </form-group>
                </div>
              </div>
            </form-body>
          </div>
        </div>
      </form>
    </div>
  </App>
</template>

<script>
import {Link, useForm} from "@inertiajs/inertia-vue3";
import App from "@layout/App";
import Datatable from "@forms/Datatable";
import SubmitButton from "@forms/SubmitButton";
import FormGroup from "@forms/FormGroup";
import FormBody from "@forms/FormBody";
import Datepicker from "@forms/Datepicker";

import {error} from "@settings/toastr";
import {ref} from "vue";
import {success} from "../../Settings/toastr";

export default {
  props: ['config'],

  components: {
    FormBody,
    FormGroup,
    SubmitButton,
    App,
    Link,
    Datatable,
    Datepicker
  },
  mounted() {
    this.init();
  },

  setup(props) {
    const form = useForm({...props.config})
    return {form};
  },

  data: _ => ({
    loading: false,
  }),

  methods: {
    init() {
      this.emitter.emit('title', 'Configurações');

      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Configurações'}
      ]);

      this.emitter.emit('action', {show: false});
    },

    submit() {
      this.form.post(this.route('app.core.configs.update'), {
        onError: error,
        onSuccess: () => { success('Configurações alteradas com sucesso!') }
      });
    },
  }
};
</script>
